import {
  PermissionSet,
  useBusinessContext,
  usePermission,
  usePermissionsLoaded
} from '@root/context'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchAccountBalances } from '../accounts'

const useAccountBalance = () => {
  const { slug } = useBusinessContext()
  const permissionsLoaded = usePermissionsLoaded()
  const canFetchAccountBalances = usePermission(PermissionSet.ACCOUNTS_VIEW)

  return useQuery({
    queryKey: [slug, 'accountBalances'],
    queryFn: () => fetchAccountBalances({ slug }),
    ...{
      enabled: Boolean(slug) && permissionsLoaded && canFetchAccountBalances,
      placeholderData: keepPreviousData,
      // Balances sync hourly; reconnecting a bank invalidates this key.
      staleTime: 1000 * 60 * 15
    }
  })
}

export default useAccountBalance
